export default __webpack_public_path__ + "static/media/011-caravan.231f4457.png";